module.exports = __webpack_public_path__ + "media/images/cleaning/cover-mobile@3x-64b5e4410f265469992fa5a54a118d2e.jpg";